import PropTypes from 'prop-types';
import React from 'react';

// ---------------------------------------------------------

import RealtorCard from '@components/realtor-card';

// ---------------------------------------------------------

import { two_agents, realtor_card } from './styles.module.scss';

// ---------------------------------------------------------

const FormRealtorCards = ({
  hasTour = true,
  setModalIsOpen = () => {},
  onListingPage = false,
  realtors
}) => {
  if (!realtors) {
    return;
  }

  return realtors.length === 2 ? (
    <div className={two_agents}>
      <RealtorCard
        key={`rc-${realtors[0].agentId}`}
        contact={realtors[0]}
        theme="horizontalSmall"
        onListingPage={onListingPage}
        hasTour={hasTour}
        setModalIsOpen={setModalIsOpen}
      />
      <RealtorCard
        key={`rc-${realtors[0].agentId}`}
        theme="horizontalSmallStacked"
        onListingPage={onListingPage}
        contact={realtors[1]}
        hasTour={hasTour}
        setModalIsOpen={setModalIsOpen}
      />
    </div>
  ) : (
    <div className={realtor_card}>
      <RealtorCard
        theme="primary"
        onListingPage={onListingPage}
        contact={realtors[0]}
        hasTour={hasTour}
        setModalIsOpen={setModalIsOpen}
      />
    </div>
  );
};

FormRealtorCards.propTypes = {
  hasTour: PropTypes.bool,
  onListingPage: PropTypes.bool,
  setModalIsOpen: PropTypes.func,
  realtors: PropTypes.array
};

export default FormRealtorCards;
